export type BankReconciliationTab = "to-reconcile" | "reconciled" | "all";

const TAB_LABELS: Record<BankReconciliationTab, string> = {
  "to-reconcile": "To reconcile",
  reconciled: "Reconciled",
  all: "All transactions",
};

type Props = {
  active: BankReconciliationTab;
  onChange: (tab: BankReconciliationTab) => void;
  counts: Record<BankReconciliationTab, number>;
};

export function BankReconciliationTabs({ active, onChange, counts }: Props) {
  const tabs: BankReconciliationTab[] = ["to-reconcile", "reconciled", "all"];

  return (
    <div
      role="tablist"
      aria-label="Reconciliation views"
      className="inline-flex rounded-lg border border-slate-200 bg-slate-100 p-1"
    >
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={active === tab}
          onClick={() => onChange(tab)}
          className={`rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${
            active === tab
              ? "bg-white text-slate-900 shadow-sm"
              : "text-slate-500 hover:text-slate-700"
          }`}
        >
          {TAB_LABELS[tab]}
          <span className="ml-1.5 tabular-nums text-slate-400">
            ({counts[tab]})
          </span>
        </button>
      ))}
    </div>
  );
}
